import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
  static targets = ["canvas"]

  connect() {
    this.shootConfetti()
  }

  async shootConfetti() {
    const canvas = this.canvasTarget
    if (!canvas) return

    const endTime = Date.now() + (20 * 1000)
    canvas.confetti = canvas.confetti || confetti.create(canvas, { resize: true })

    while (Date.now() < endTime) {
      canvas.confetti({
        particleCount: 6,
        ticks: 160,
        spread: 100,
        origin: { x: 0.5, y: 0 },
      })

      await new Promise(resolve => requestAnimationFrame(resolve))
    }
  }
}
